import React from 'react';
import ReactDOM from 'react-dom';

//custom Components
import Iconset from './icons';
//custom styles
import '../styles/video-trigger-screen.scss';
		
class VideoTrigger extends React.Component{

	componentWillReceiveProps(nextProps){
		
	}

	render(){

		
	
		return (<div className="video-trigger-screen">
				<div className="logo-icon">
					<Iconset.logo />
				</div>
				<div className="video-trigger-screen-inner absolute">
					<div className="load-status">
						<h2>Ready for the live session?</h2>
						<button className="video-trigger" onClick={this.props.play}>start</button>
					</div>					
				</div>
			</div>);
	}
}

export default VideoTrigger;


// WEBPACK FOOTER //
// ./src/scripts/videoTrigger.js